/**
 * Layout-константы уровня приложения.
 *
 * Здесь живут размеры, которые "обвязывают" разные части layout (PageHeader,
 * PageTemplate, sidebar — последний имеет свой sidebar.constants.ts).
 *
 * Когда добавлять сюда:
 *   - значение используется в 2+ компонентах layout-слоя
 *   - значение определяет визуальное равновесие модульной сетки
 *
 * Когда НЕ добавлять сюда:
 *   - константа специфична для одного компонента → оставить рядом с ним
 *   - это цвет/радиус/тень → это в tokens.ts
 */

/**
 * Максимальная ширина контентной зоны страницы.
 *
 * 1700px выбраны осознанно: на 2560px-мониторах глаз устаёт пробегать
 * от первой колонки таблицы до последней. 1700px даёт достаточно места
 * для плотных таблиц с большим количеством колонок и при этом сохраняет
 * комфортную read-distance для текстовых ячеек.
 *
 * Применимо для НЕ-fullscreen страниц. Для карт / истории маршрутов
 * (fullscreen) применяется тот же лимит — карта внутри сама держится
 * 100% контейнера.
 */
export const PAGE_MAX_WIDTH = 1700;

/**
 * Высота PageHeader на десктопе.
 *
 * 56px = совпадает с высотой Logo в sidebar и высотой mobile AppNavbar.
 * Это даёт единую горизонтальную линию по всему приложению — глаз
 * считывает её как "верх рабочей области".
 */
export const PAGE_HEADER_HEIGHT = 56;

/**
 * Высота мобильного AppNavbar (fixed). Должна совпадать с компенсирующим
 * отступом контента в App.tsx — иначе контент лезет под навбар («прилипание»).
 * Держим в одной константе, чтобы навбар и компенсация не разошлись.
 */
export const MOBILE_NAVBAR_HEIGHT = 56;